// Classes.
import {BaseLocator} from './../locators/base.locator';
import { CategoryLocatorComponent } from './category.locator-component';


export class CategoryListLocator extends BaseLocator {
  category : CategoryLocatorComponent;
  constructor() {
    super('categoryList');
    this.addComponentByType('category');
  }
}

